import { IQuickFilterContext } from 'framework/IQuickFilterContext';
import React from 'react';
import { QuickFilter } from '../ReservationsList';

interface IViewContext extends IQuickFilterContext<QuickFilter> {
}

export const ReservationsViewContext = React.createContext<IViewContext>(undefined as any);
